module.exports = __webpack_public_path__ + "img/hammam_MALAGA.41084608.jpg";